const PortfolioCard = ({ text }) => (
    <div className="rounded-2xl bg-white border border-secondary-200 shadow-soft p-5">
        <div className="font-semibold text-secondary-900 mb-2">Портфолио</div>
        <div className="text-secondary-700 whitespace-pre-line">{text}</div>
    </div>
);

export default PortfolioCard;
